module.exports = __webpack_public_path__ + "static/media/Review3.0802a28a.webp";